import {connect} from '@modifi/redux'
import {compose} from 'ramda'
import {aPush} from '@modifi/router'
import {withSuspense} from '@modifi/plugin-onboarding'

import {FeInputFieldStatus} from '@modifi/enums'
import CreateLegalRepresentative, {
  CreateLegalRepresentativeProps,
} from './CreateLegalRepresentative'
import {
  aInitializePage,
  aReset,
  aSavePage,
  selectInitialFormData,
  selectInitializePagePending,
  selectSaveErrorMessage,
  selectSaveHasError,
  selectSavePending,
} from '../store/form'
import {selectAvailableDataSourceOptions, aSelectPersonAsDataSource} from '../store/data-source'
import {selectCombinedInputFieldStatusBySectionName} from '../../../../modules/input-fields'
import {SECTION_LEGAL_REPRESENTATIVES} from '../../../../constants/sections'
import {selectIsAnyRoleBasedFieldsVisible} from '../store/selectors'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const mapStateToProps = (
  state: Record<string, any>,
  ownProps: Record<string, any>
): Pick<
  CreateLegalRepresentativeProps,
  | 'externalCompanyId'
  | 'isLoading'
  | 'updatePending'
  | 'formData'
  | 'hasError'
  | 'errorMessage'
  | 'dataSources'
  | 'pageIsVerified'
  | 'hasAnyRoleBasedFieldsVisible'
> => {
  const externalCompanyId = ownProps?.match?.params?.externalCompanyId
  const externalPersonId = ownProps?.match?.params?.externalId

  return {
    externalCompanyId,
    // externalPersonId,
    isLoading: selectInitializePagePending(state, externalPersonId),
    updatePending: selectSavePending(state),
    formData: selectInitialFormData(state, externalPersonId),
    hasError: selectSaveHasError(state),
    errorMessage: selectSaveErrorMessage(state),
    dataSources: selectAvailableDataSourceOptions(state),
    pageIsVerified:
      selectCombinedInputFieldStatusBySectionName(state, SECTION_LEGAL_REPRESENTATIVES) ===
      FeInputFieldStatus.VERIFIED,
    hasAnyRoleBasedFieldsVisible: selectIsAnyRoleBasedFieldsVisible(state),
  }
}

const mapDispatchToProps = {
  initialize: aInitializePage,
  onSubmit: aSavePage,
  onDiscard: aReset,
  onSelectDataSource: aSelectPersonAsDataSource,
  redirect: aPush,
}

export default compose(
  withSuspense(false),
  connect(mapStateToProps, mapDispatchToProps)
)(CreateLegalRepresentative)
